import { observer } from "mobx-react";
import React, { useEffect } from "react";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { View } from "~/components/V2/View";
import { useStore } from "~/mobx/utils/useStore";
import { styleConstantsV2 as C } from "~/style/styleConstantsV2";

export const ProgressBar = observer(function ProgresBar({
  shouldAnimateProgressBar = true,
}: {
  shouldAnimateProgressBar: boolean;
}) {
  const store = useStore();

  const step = store.bookingStore.currentProgressBarStep;
  const totalSteps = store.bookingStore.totalProgressBarSteps;

  const startingWidth = useSharedValue(((step - 1) / totalSteps) * 100);

  const isLastStep = step === totalSteps;

  const animatedStyle = useAnimatedStyle(() => ({
    width: `${startingWidth.value}%`,
    backgroundColor: C.colorGrey,
    height: 8,
    borderTopRightRadius: isLastStep ? 0 : 4,
    borderBottomRightRadius: isLastStep ? 0 : 4,
  }));

  useEffect(() => {
    // animate progressbar

    if (!shouldAnimateProgressBar) {
      return;
    }
    startingWidth.value = withTiming((step / totalSteps) * 100, {
      duration: 600,
    });
  }, [shouldAnimateProgressBar, startingWidth, step, totalSteps]);

  return (
    <View style={{ backgroundColor: C.colorGrey10, height: 8, width: "100%" }}>
      <Animated.View style={animatedStyle} />
    </View>
  );
});
